/**
 * Los niveles de `activity_logs` pueden venir en español (valores reales que
 * guarda la base: CRÍTICO, ERROR, INFORMACIÓN, ADVERTENCIA) o en inglés
 * (INFO, WARNING, ERROR, CRITICAL). Todo el sistema de filtros y limpieza
 * debe funcionar con ambos sin depender de tildes.
 */

export type LogLevelKey = 'info' | 'warning' | 'error' | 'critical';

export const LEVEL_ORDER: LogLevelKey[] = ['info', 'warning', 'error', 'critical'];

/**
 * Filtros PostgREST tolerantes: `inform%` atrapa INFO e INFORMACIÓN,
 * `advert%` atrapa ADVERTENCIA, y `cr%tic%` atrapa CRÍTICO/CRITICO/CRITICAL.
 */
export const LEVEL_FILTERS: Record<LogLevelKey, string> = {
  info: 'level.ilike.inform%',
  warning: 'level.ilike.advert%,level.ilike.aviso%,level.ilike.warning%',
  error: 'level.ilike.error%',
  critical: 'level.ilike.cr%tic%',
};

/** Niveles que la limpieza puede vaciar. ERROR y CRÍTICO nunca entran aquí. */
export const PURGEABLE_LEVEL_KEYS: LogLevelKey[] = ['info', 'warning'];

/** Filtro combinado de éxito + aviso, usado para contar y borrar. */
export const PURGEABLE_LEVEL_FILTER =
  'level.ilike.inform%,level.ilike.advert%,level.ilike.aviso%,level.ilike.warning%';

/** Filtro combinado de errores + críticos. */
export const ERROR_LEVEL_FILTER = 'level.ilike.error%,level.ilike.cr%tic%';

export function resolveLevelKey(raw: string | null | undefined): LogLevelKey {
  const value = (raw ?? '').trim().toUpperCase();
  if (value.startsWith('INFORM') || value === 'INFO') return 'info';
  if (value.startsWith('ADVERT') || value === 'AVISO' || value === 'WARNING') return 'warning';
  if (value.startsWith('CRIT') || value.startsWith('CRÍT')) return 'critical';
  return 'error';
}